export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  query?: Record<string, string>
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'dashboard',
      },
    },
    {
      name: 'users',
      displayName: 'menu.users',
      meta: {
        icon: 'group',
      },
      children: [
        {
          name: 'user-list',
          displayName: 'menu.user-list',
          meta: {
            icon: 'person',
          },
        },
        {
          name: 'user-roles',
          displayName: 'menu.user-roles',
          meta: {
            icon: 'security',
          },
        },
      ],
    },
    {
      name: 'developer',
      displayName: 'menu.developer',
      meta: {
        icon: 'code',
      },
      children: [
        {
          name: 'apps-list',
          displayName: 'menu.apps-list',
          meta: { icon: 'app_registration' },
        },
        {
          name: 'webhooks',
          displayName: 'menu.webhooks',
          meta: { icon: 'webhook' },
        },
        {
          name: 'sdk',
          displayName: 'menu.sdk',
          meta: { icon: 'terminal' },
        },
        {
          name: 'messaging',
          displayName: 'menu.nx-messaging',
          meta: { icon: 'forum' },
        },
        {
          name: 'presence-guide',
          displayName: 'menu.nx-presence',
          meta: { icon: 'sensors' },
        },
        {
          name: 'streaming-guide',
          displayName: 'menu.nx-streaming',
          meta: { icon: 'dynamic_feed' },
        },
        {
          name: 'call-guide',
          displayName: 'menu.nx-call',
          meta: { icon: 'video_call' },
        },

        {
          name: 'push-guide',
          displayName: 'menu.nx-push',
          meta: { icon: 'notifications_active' },
        },
        {
          name: 'iot-core-guide',
          displayName: 'menu.nx-iot-core',
          meta: { icon: 'memory' },
        },
      ],
    },
    // {
    //   name: 'cloud',
    //   displayName: 'menu.cloud',
    //   meta: {
    //     icon: 'cloud',
    //   },
    //   children: [
    //     {
    //       name: 'cloud-storage',
    //       displayName: 'menu.cloud-storage',
    //       meta: { icon: 'cloud_upload' },
    //     },
    //     {
    //       name: 'cloud-functions',
    //       displayName: 'menu.cloud-functions',
    //       meta: { icon: 'functions' },
    //     },
    //     {
    //       name: 'data-analysis',
    //       displayName: 'menu.data-analysis',
    //       meta: { icon: 'analytics' },
    //     },
    //   ],
    // },
    {
      name: 'documentation',
      displayName: 'menu.documentation',
      meta: {
        icon: 'description',
      },
      children: [
        {
          name: 'api-docs',
          displayName: 'menu.api-docs',
          meta: { icon: 'api' },
        },
        {
          name: 'integration-guides',
          displayName: 'menu.integration-guides',
          meta: { icon: 'integration_instructions' },
        },
        {
          name: 'tutorials',
          displayName: 'menu.tutorials',
          meta: { icon: 'school' },
        },
      ],
    },
    {
      name: 'iot-service',
      displayName: 'menu.iot-service',
      meta: { icon: 'memory' },
    },
    {
      name: 'services-subscribution',
      displayName: 'menu.services',
      meta: { icon: 'business_center' },
      children: [
        {
          name: 'services-subscribution',
          displayName: 'menu.browse-services',
          meta: { icon: 'apps' },
        },
        {
          name: 'services-subscribution',
          displayName: 'menu.my-subscriptions',
          meta: { icon: 'verified' },
          query: { tab: 'subscriptions' },
        },
      ],
    },
    {
      name: 'settings',
      displayName: 'menu.settings',
      meta: {
        icon: 'settings',
      },
      children: [
        {
          name: 'account',
          displayName: 'menu.account',
          meta: { icon: 'manage_accounts' },
        },
        {
          name: 'security',
          displayName: 'menu.security',
          meta: { icon: 'shield' },
        },
        {
          name: 'notifications',
          displayName: 'menu.notifications',
          meta: { icon: 'notifications' },
        },
      ],
    },
  ] as INavigationRoute[],
}
